import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Alert, Form, Button } from 'react-bootstrap';
import { Input, DateTimeInput, FormActions, Static } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';
import ui from '../../common/services/ui';

const SettingsForm = ({ parentId, error, handleSubmit, pristine, submitting, submitSucceeded, isReadonly, genderTypes, requireChildSchool, initialValues, t }) => {
	const showGender = false;
	const sameAsParent = initialValues && initialValues.sameAsParent;

	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			{sameAsParent && <Field name='fullName' component={Static} horizontal label={t('Child_FullName')} />}
			{!sameAsParent && <Field name='firstName' component={Input} horizontal required type='text' label={t('Child_FirstName')} validate={validators.required} />}
			{!sameAsParent && <Field name='middleName' component={Input} horizontal type='text' label={t('Child_MiddleName')} />}
			{!sameAsParent && <Field name='lastName' component={Input} horizontal type='text' label={t('Child_LastName')} />}
			{!sameAsParent && requireChildSchool && <Field name='schoolName' component={Input} horizontal type='text' label={t('Child_SchoolName')} required={requireChildSchool && !sameAsParent} validate={requireChildSchool && validators.required}  />}
			{showGender && <Field name='genderTypeId' component={Input} componentClass='select' horizontal label={t('Child_Gender')}>
				<option />
				{ui.makeOptionValues(genderTypes)}
			</Field>}
			<Field name='dateOfBirth' component={DateTimeInput} disabled={isReadonly} horizontal required showTime={false} label={t('Child_DateOfBirth')} validate={[validators.required, validators.dateInThePast]} />
			<Field name='dateOfBirth' component={Static} horizontal label={t('Child_Age_Title')} valueWrapper={value => <span>{ui.formatAge(value)}</span>} validate={[validators.required, validators.dateInThePast]} />
			<Field name='isDeleted' component={Input} horizontal componentClass='select' label={t('Child_IsDeleted')} disabled={true}>
				<option value={true}>{t('Common_Yes')}</option>
				<option value={false}>{t('Common_No')}</option>
			</Field>
			<FormActions horizontal>
				<Button type='submit' disabled={pristine || submitting} bsStyle='primary'>{t('Common_Save')}</Button>
			</FormActions>
		</Form>
	);
};

export default reduxForm({ form: 'child', enableReinitialize: true })(withTranslation()(SettingsForm));
